<template>
  <div class="modal-content">
    <img src="@images/icon/ico_logo.png" alt="" height="142" width="142">
    <p class="title" v-html="$t('connect.text001')" />
    <p class="title" v-html="$t('connect.text002')" />
    <ul class="text-list">
      <li class="text-item" v-html="$t('connect.text003')" />
      <li class="text-item" v-html="$t('connect.text004')" />
      <li class="text-item" v-html="$t('connect.text005')" />
    </ul>
    <a class="button" v-html="$t('connect.btn003')" :href="`/login?url=${redirectUrl}`" />
    <div class="link-about-wrapper">
      <a
        href="https://my.nintendo.com/getting_started"
        target="_blank"
        class="link-about"
        v-html="$t('connect.text006')"
      />
    </div>
    <a class="button" @click="hideModal" v-html="$t('connect.btn004')" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import localeModal from '@locales/modal'

export default {
  name: 'modal-na-link-for-mypage',
  $messages: localeModal,
  computed: {
    redirectUrl() {
      return `${location.origin}/${this.$route.params.lang}/mypage`
    }
  },
  methods: {
    ...mapActions('modal', ['hideModal']),
  },
}
</script>


<style lang="scss" scoped>
.modal-content {
  padding-top: 80px;
  text-align: center;
}
.title {
  font-size: $fs-large;
  text-shadow: $ts-base;
  margin: 16px auto;;
  display: block;
  width: 80%;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(~@images/modal/btn_general.png);
  background-repeat: no-repeat;
  background-size: 500px 113px;
  width: 500px;
  height: 113px;
  font-size: 3rem;
  text-shadow: $ts-base;
  margin: 0 auto;
  @include tap-event();
}
.text-list {
  width: 460px;
  margin: 0 auto 20px;
  text-align: left;
}
.text-item {
  font-size: $fs-large;
  text-shadow: $ts-base;
  padding-left: 40px;
  position: relative;
  &:before {
    content: '';
    display: inline-block;
    background-image: url(~@images/icon/ico_bullet.png);
    background-repeat: no-repeat;
    background-size: 20px 20px;
    background-position: 0 8px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
  }
}
.link-about-wrapper {
  margin: 10px 0 20px;
}
.link-about {
  padding-left: 40px;
  position: relative;
  color: #fff;
  text-shadow: $ts-base;
  font-size: $fs-middle;
  &:before {
    content: '';
    display: inline-block;
    background-image: url(~@images/icon/ico_arrow.png);
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 40px;
    height: 29px;
  }
}
</style>
